import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import unit from "./unitReducer";
import campaign from "./campaignReducer";
import brand from "./brandReducer";
import search from "./searchReducer";
import latestUnits from "./latestUnitReducer";
import user from "./userReducer";

export default (history) => combineReducers({
    user,
    unit,
    campaign,
    brand,
    search,
    latestUnits,
    router: connectRouter(history)
})
